const constants_anonymous = {
    SET_LISTING: 'SET_LISTING',
    SET_LISTING_STATUS: 'SET_LISTING_STATUS',
    SET_LISTING_AVAILABILITY: 'SET_LISTING_AVAILABILITY',
    SET_LISTINGS: 'SET_LISTINGS',

    SET_CREDIT_EXAM: 'SET_CREDIT_EXAM',
    SET_CREDIT_EXAM_STATUS: 'SET_CREDIT_EXAM_STATUS',
    SET_CREDIT_ANSWERS: 'SET_CREDIT_ANSWERS',
    SET_IDMA_STATUS: 'SET_IDMA_STATUS',

    SET_GUARANTOR: 'SET_GUARANTOR',
    SET_GUARANTOR_VERIFIED: 'SET_GUARANTOR_VERIFIED',

    SET_REFERENCE: 'SET_REFERENCE',
};

const constants_display = {
    NAVBAR_SHOW: 'NAVBAR_SHOW',
    NAVBAR_TOGGLE_DROPDOWN: 'NAVBAR_TOGGLE_DROPDOWN',
    NAVBAR_TOGGLE_MOBILE: 'NAVBAR_TOGGLE_MOBILE',

    FOOTER_SHOW: 'FOOTER_SHOW',

    SHOW_ADD_PROPERTY_MODAL: 'SHOW_ADD_PROPERTY_MODAL',
    SHOW_ADD_LISTING_MODAL: 'SHOW_ADD_LISTING_MODAL',
    SHOW_INVITE_TENANT_MODAL: 'SHOW_INVITE_TENANT_MODAL',

    SET_APPLICATION_KEY: 'SET_APPLICATION_KEY',
    INCREMENT_APPLICATION_KEY: 'INCREMENT_APPLICATION_KEY',
    DECREMENT_APPLICATION_KEY: 'DECREMENT_APPLICATION_KEY',
    SET_APPLICATION_SHOW_ADD_HISTORY: 'SET_APPLICATION_SHOW_ADD_HISTORY',

    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_IS_WORKING: 'SET_IS_WORKING',

    ADD_FLOW_KEY: 'ADD_FLOW_KEY',
    REMOVE_FLOW_KEY: 'REMOVE_FLOW_KEY',
    SET_FLOW_KEY: 'SET_FLOW_KEY',
    INC_FLOW_KEY: 'INC_FLOW_KEY',

    DISPLAY_CONFIRM_MODAL: 'DISPLAY_CONFIRM_MODAL',
    HIDE_CONFIRM_MODAL: 'HIDE_CONFIRM_MODAL',
    SET_CONFIRM_MODAL_ACTING: 'SET_CONFIRM_MODAL_ACTING',

    DISPLAY_MODAL: 'DISPLAY_MODAL',
    HIDE_MODAL: 'HIDE_MODAL',
    UPDATE_MODAL: 'UPDATE_MODAL',

    DISPLAY_OVERLAY: 'DISPLAY_OVERLAY',
    HIDE_OVERLAY: 'HIDE_OVERLAY',
    UPDATE_OVERLAY: 'UPDATE_OVERLAY',
};

const constants_owner = {
    SET_OWNER: 'SET_OWNER',
    SET_OWNER_INVOLVEMENT: 'SET_OWNER_INVOLVEMENT',

    ADD_PROPERTY: 'ADD_PROPERTY',

    SET_PROPERTY_ROOMMATE_GROUPS: 'SET_PROPERTY_ROOMMATE_GROUPS',
    SET_OWNER_PROPERTIES: 'SET_OWNER_PROPERTIES',
    SET_PROPERTY_LISTINGS: 'SET_PROPERTY_LISTINGS',

    EDIT_PROPERTY_LISTING: 'EDIT_PROPERTY_LISTING',
};

const constants_tenant = {
    SET_TENANT: 'SET_TENANT',

    SET_TENANT_APPLICATION: 'SET_TENANT_APPLICATION',
    SET_TENANT_SKIP_GUARANTOR: 'SET_TENANT_SKIP_GUARANTOR',
    SET_TENANT_EMPLOYMENT_HISTORY: 'SET_TENANT_EMPLOYMENT_HISTORY',
    SET_TENANT_INVITATIONS: 'SET_TENANT_INVITATIONS',
    SET_TENANT_RENTAL_HISTORY: 'SET_TENANT_RENTAL_HISTORY',
    SET_TENANT_ROOMMATE_GROUP: 'SET_TENANT_ROOMMATE_GROUP',

    SET_TENANT_BILLING_STATUS: 'SET_TENANT_BILLING_STATUS',
    SET_TENANT_BILLING_HISTORY: 'SET_TENANT_BILLING_HISTORY',
    SET_TENANT_BILLING_METHOD: 'SET_TENANT_BILLING_METHOD',
    SET_TENANT_STRIPE_DETAILS: 'SET_TENANT_STRIPE_DETAILS',

    SET_TENANT_LISTINGS: 'SET_TENANT_LISTINGS',
    SET_TENANT_RECOMMENDED_LISTINGS: 'SET_TENANT_RECOMMENDED_LISTINGS',
    SET_TENANT_LISTING_PREFERENCES: 'SET_TENANT_LISTING_PREFERENCES',
    SET_TENANT_LISTING_PREF_RENT: 'SET_TENANT_LISTING_PREF_RENT',
    SET_TENANT_LISTING_PREF_BED: 'SET_TENANT_LISTING_PREF_BED',
    SET_TENANT_LISTING_PREF_BATH: 'SET_TENANT_LISTING_PREF_BATH',
    SET_TENANT_MIN_LEASE_START: 'SET_TENANT_MIN_LEASE_START',
    SET_TENANT_MAX_LEASE_START: 'SET_TENANT_MAX_LEASE_START',

    ADD_INTEREST_LIST: 'ADD_INTEREST_LIST',
    REMOVE_INTEREST_LIST: 'REMOVE_INTEREST_LIST',
    SET_INTEREST_LIST: 'SET_INTEREST_LIST',
};

const constants_unclaimed = {
    SET_UNCLAIMED_PROPERTIES: 'SET_UNCLAIMED_PROPERTIES'
};

const constants_user = {
    SET_USER: 'SET_USER',
    CLEAR_USER: 'CLEAR_USER',
    FETCH_USER: 'FETCH_USER',
};

const constants = {
    ...constants_anonymous,
    ...constants_display,
    ...constants_owner,
    ...constants_tenant,
    ...constants_unclaimed,
    ...constants_user,

    CANCEL_FETCHING: 'CANCEL_FETCHING',
    ADD_ERROR: 'ADD_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',

};

export default constants;


// WEBPACK FOOTER //
// ./src/constants.js